import { useEffect, useRef, useState } from "react";
import { FiSearch, FiX } from "react-icons/fi";

export const SEARCH_DELAY = 350;
export default function CatalogueSearch({ searchTerm, onSearch, label = "Search books", formLabel = "Search the catalogue", id = "catalogue-search" }) {
	const [value, setValue] = useState(searchTerm);
	const [composing, setComposing] = useState(false);
	const timer = useRef(null);
	const input = useRef(null);
	useEffect(() => { setValue(searchTerm); }, [searchTerm]);
	useEffect(() => {
		if (composing || value.trim() === searchTerm) return undefined;
		timer.current = setTimeout(() => onSearch(value.trim(), { replace: true }), SEARCH_DELAY);
		return () => clearTimeout(timer.current);
	}, [value, searchTerm, composing, onSearch]);
	const submit = (event) => {
		event.preventDefault();
		clearTimeout(timer.current);
		if (value.trim() !== searchTerm) onSearch(value.trim());
		setValue(value.trim());
	};
	const clear = () => {
		clearTimeout(timer.current);
		setValue("");
		if (searchTerm) onSearch("");
		input.current?.focus();
	};
	return (
		<div className="catalogue-search-panel">
			<form role="search" aria-label={formLabel} onSubmit={submit} className="catalogue-search">
				<label className="sr-only" htmlFor={id}>{label}</label>
				<FiSearch aria-hidden="true" />
				<input ref={input} id={id} type="search" value={value} placeholder="Search by title, author or ISBN" aria-describedby={id + "-hint"} autoComplete="off" maxLength={255}
					onChange={(event) => setValue(event.target.value)} onCompositionStart={() => setComposing(true)} onCompositionEnd={() => setComposing(false)} />
				{value && <button type="button" className="catalogue-search-clear" aria-label="Clear search" onClick={clear}><FiX aria-hidden="true" /></button>}
				<button className="catalogue-primary" type="submit">Search</button>
			</form>
			<p id={id + "-hint"}>Search updates as you type.</p>
		</div>
	);
}
